import { render, staticRenderFns } from "./OrdersSettlementsPopup.vue?vue&type=template&id=65c6d4f6&scoped=true&"
import script from "./OrdersSettlementsPopup.vue?vue&type=script&lang=js&"
export * from "./OrdersSettlementsPopup.vue?vue&type=script&lang=js&"
import style0 from "./OrdersSettlementsPopup.vue?vue&type=style&index=0&id=65c6d4f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6d4f6",
  null
  
)

export default component.exports